import { styled, keyframes } from '@abyss/web/tools/styled';
import { Box } from '@abyss/web/ui/Box';
import { MEDIA_QUERY } from '@pass-frontend/abyss/utility/style-helpers';
import { useIntl } from '@pass-frontend/common/i18n';
import { GymPartnersDataProps } from '@pass-frontend/features/standalone/data-access';

const CSS_BOX = {
  height: '165px',
  [MEDIA_QUERY.mobile]: {
    height: '96px',
  },
};

const StyledImage = styled('img', {
  width: '200px',
  maxHeight: '70px',
  objectFit: 'contain',
  margin: '0 40px',
  borderRadius: '$sm',
  flexShrink: 0,
  display: 'block',

  [MEDIA_QUERY.mobile]: {
    width: '100px',
    margin: '0 12px',
  },
});

const scroll = keyframes({
  '0%': {
    transform: 'translateX(0)',
  },
  '100%': {
    transform: 'translateX(-50%)',
  },
});

const StyleDiv = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  animation: `${scroll} 32s linear infinite`,
  width: 'max-content',
});

const StyledBanner = styled('div', {
  display: 'flex',
  width: '100%',
  overflow: 'hidden',
  whitespace: 'nowrap',
  color: '$tint7',

  '&:hover': {
    animationPlayState: 'paused',
  },
});

export const GymPartnersNew = ({ images }: GymPartnersDataProps) => {
  // Duplicate images to create seamless loop
  const duplicated = [...images, ...images];
  const { t } = useIntl();

  return (
    <Box color="$tint7" css={CSS_BOX}>
      <StyledBanner>
        <StyleDiv style={{ animationDuration: `32s` }}>
          {duplicated.map(({ url, altTextKey }, index) => (
            <StyledImage key={index} src={url} alt={t(altTextKey)} />
          ))}
        </StyleDiv>
      </StyledBanner>
    </Box>
  );
};
